import { log } from '@domgen/shared/utils/log';
import { captureErrorNavigation } from '../../../services/posthog/capture';
import { EventObject } from '@xstate/store-react';
import { AppRoute } from '../../../enums/appRoutes';
import { StoreEvent } from '../../../enums/storeEvent';
import { StoreContext } from '../../../models/store/context';

/**
 * Handles checkout failure by routing to the error page.
 *
 * @param context Current store context.
 * @param _event Unused event payload.
 * @param enqueue Store enqueue helpers used for navigation emission.
 * @returns Unchanged context.
 */
export const checkoutFailed = <T extends EventObject = EventObject>(
  context: StoreContext,
  _event: T,
  enqueue: {
    effect: (effect: () => Promise<void>) => void;
    emit: { navigate: (payload: { path: AppRoute; replace?: boolean }) => void };
  },
): StoreContext => {
  log.debug({ message: StoreEvent.CHECKOUT_FAILED });
  captureErrorNavigation('checkout-failed');
  enqueue.emit.navigate({ path: AppRoute.ERROR, replace: true });
  return context;
};
